import { SCORING_DATA_LOADED } from '../actions/scoringActions';

export default function scoringReducer(state = {}, action) {
    switch (action.type) {
        case SCORING_DATA_LOADED:
            return Object.assign({}, state, {
                influencers: action.influencers
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/scoringReducer.js